import { useSuspenseQuery } from '@apollo/client/react';

import { SuggestedChangesView } from '@/components/SuggestChanges';
import { apolloCache as cache } from 'src/graphql/client/apollo-client';
import { AssetContentTypeEnum, SuggestedChangeChangeTypeEnum } from 'src/graphql/schema';
import { AssetsDocument } from 'src/graphql/actions/asset/assets.query';
import {
  SuggestedChangesDocument,
  ISuggestedChangesQuery,
} from 'src/graphql/actions/suggestChanges/suggestedChanges.query';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { withSuspense } from 'src/hoc';

type Props = {
  contentType?: AssetContentTypeEnum;
};

const SuggestedChangesBlock = ({ contentType }: Props) => {
  const { softwareEscrow } = useSoftwareEscrow();
  const suggestedChanges = cache.readQuery<ISuggestedChangesQuery>({
    query: SuggestedChangesDocument,
    variables: {
      escrowId: softwareEscrow.id,
      changeType: SuggestedChangeChangeTypeEnum.DepositSuggestedChange,
    },
  });

  const assetsIds =
    suggestedChanges?.suggestedChanges.nodes[0]?.payload?.deleted_assets?.map((asset: { id: string }) => asset?.id) ||
    [];
  const { data } = useSuspenseQuery(AssetsDocument, {
    variables: {
      softwareEscrowId: softwareEscrow.id,
      ids: assetsIds,
      perPage: assetsIds.length,
      labeled: !!contentType,
      ...(contentType && { contentType }),
    },
    skip: !assetsIds.length,
  });

  const suggestedChangesItems = data?.assets.nodes.map((asset) => ({
    label: asset.depositSource || 'Unknown',
    value: 'removed from escrow',
  }));

  if (!suggestedChangesItems) return null;

  return <SuggestedChangesView items={suggestedChangesItems} />;
};

const Fallback = () => null;

export default withSuspense(SuggestedChangesBlock, Fallback);
